import {PreferredPaymentMethodEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function driverPreferredPaymentMethodNameFilter(type: PreferredPaymentMethodEnum): string {
  switch (type) {
    case PreferredPaymentMethodEnum.Transfer: return i18n.t(LF.Transfer) as string;
    case PreferredPaymentMethodEnum.Cash:  return i18n.t(LF.Cash) as string;
    case PreferredPaymentMethodEnum.Blik:  return i18n.t(LF.Blik) as string;
    case PreferredPaymentMethodEnum.IngCard:  return i18n.t(LF.IngCard) as string;
    case PreferredPaymentMethodEnum.Revolut:  return i18n.t(LF.Revolut) as string;
  }
}
